import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { orderFragment } from '../lib/order/fragments/order-fragment';

export const query = gql`
  mutation CompleteGameOrder(
    $orderId: PositiveInt!
    $payAmount: Int!
    $timeZone: String!
    $nonce: String
    $storeInVault: Boolean
    $referringGameId: Int
    $awinAffiliateInfo: JSON
    $tikTokEventApiAffiliateInfo: JSON
  ) {
    completeOrderV2(
      id: $orderId
      payAmount: $payAmount
      timeZone: $timeZone
      paymentMethodNonce: $nonce
      storeInVaultOnSuccess: $storeInVault
      referringGameId: $referringGameId
      awinAffiliateInfo: $awinAffiliateInfo
      tikTokEventApiAffiliateInfo: $tikTokEventApiAffiliateInfo
    ) {
      ...OrderFragment

      orderItems {
        id

        ... on GameOrderItem {
          showPartnerOffer
        }
      }
    }
  }

  ${orderFragment}
`;

export function useCompleteOrder({ orderId, timeZone }) {
  const [mutate] = useMutation(query);
  const completeOrder = ({
    payAmount,
    nonce,
    referringGameId,
    storeInVault,
    awinAffiliateInfo,
    tikTokEventApiAffiliateInfo,
  }) =>
    mutate({
      variables: {
        awinAffiliateInfo,
        tikTokEventApiAffiliateInfo,
        orderId,
        payAmount,
        timeZone,
        nonce,
        storeInVault,
        referringGameId,
      },
    });

  return { completeOrder };
}
